import React, { useEffect } from 'react'
import {  useDispatch } from 'react-redux'
import {
    refreshDeviceList,
    startDeviceMonitoring,
    startMonitoringCameraPermission,
    startMonitoringMicrophonePermission,
} from './store/mediaControlSlice'
import MediaControlPanel from './components/MediaControlPanel/MediaControlPanel'

export default function MediaControls() {

    const dispatch = useDispatch()

    let f = false

    useEffect(() => {
        if (f) return
        f = true
        dispatch(refreshDeviceList())
        dispatch(startDeviceMonitoring())
        dispatch(startMonitoringCameraPermission())
        dispatch(startMonitoringMicrophonePermission())
    }, [])


    return (
            <MediaControlPanel></MediaControlPanel>
    )
}